var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.625C4.75272 7.625 4.27581 7.42746 3.92417 7.07583C3.57254 6.72419 3.375 6.24728 3.375 5.75C3.375 5.25272 3.57254 4.77581 3.92417 4.42417C4.27581 4.07254 4.75272 3.875 5.25 3.875C5.74728 3.875 6.22419 4.07254 6.57583 4.42417C6.92746 4.77581 7.125 5.25272 7.125 5.75C7.125 5.99623 7.0765 6.24005 6.98227 6.46753C6.88805 6.69502 6.74994 6.90172 6.57583 7.07583C6.40172 7.24994 6.19502 7.38805 5.96753 7.48227C5.74005 7.5765 5.49623 7.625 5.25 7.625ZM5.25 0.5C3.85761 0.5 2.52226 1.05312 1.53769 2.03769C0.553123 3.02226 0 4.35761 0 5.75C0 9.6875 5.25 15.5 5.25 15.5C5.25 15.5 10.5 9.6875 10.5 5.75C10.5 4.35761 9.94688 3.02226 8.96231 2.03769C7.97774 1.05312 6.64239 0.5 5.25 0.5Z",
    fill: "url(#paint0_linear_535_101)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_535_101",
    x1: 0.16727,
    y1: 6.8905,
    x2: 10.5067,
    y2: 6.90902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1063AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#1B7E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B5D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector9);
export default __webpack_public_path__ + "static/media/vector9.078ab12a827c089b335fe24e810634cb.svg";
export { ForwardRef as ReactComponent };